import { Fragment, useRef } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import { breakpoints, vars } from '@etg/wings';
// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.
import type { SubMenuItem } from '@eti/schema-types/schema-objects';
import { css } from '@eti/styles';
import { Question } from '@phosphor-icons/react';
import SiteButtonWithDropdownMenu from './SiteButtonWithDropdownMenu';

const buttonWrapperStyles = css`
  position: relative;
`;

const buttonStyles = css`
  &:focus-visible {
    outline-color: ${vars.colors.header.content};
  }

  @media print {
    display: none;
  }
`;

interface SupportMenuProps {
  iconOnly?: boolean;
  menu: {
    menuType: string;
    name: string;
    path: string | null;
    subMenu: SubMenuItem[];
  }[];
}

const SupportMenu = ({ iconOnly = false, menu }: SupportMenuProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const isWiderViewport = useMediaQuery(`(min-width: ${breakpoints._970})`);
  const hideLabel = iconOnly || !isWiderViewport;

  return (
    <div data-testid="support-menu" ref={wrapperRef}>
      {menu.map(({ name, subMenu }, index) => (
        <Fragment key={`support-menu-${index}`}>
          {subMenu?.length > 0 && (
            <div className={buttonWrapperStyles}>
              <SiteButtonWithDropdownMenu
                align="end"
                className={buttonStyles}
                hideLabel={hideLabel}
                iconPrefix={<Question aria-hidden />}
                label={name}
                menu={subMenu}
                menuId="support-menu"
                withBorder={false}
                wrapperRef={wrapperRef}
              />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default SupportMenu;
